import {useState} from 'react';

import { useAuth } from "../app/context";

import { Section,SectionTitle,SectionDesc,Card } from "../components/reuseable"
import { PopupLarge } from "../components/reuseable/popup"

const FamilyBackground = () =>{
  
  const { isLoaded,family, translations } = useAuth();

  const [showPopup, setShowPopup] = useState(false);

  const openModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowPopup(true);
  };

  const closeModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowPopup(false);
  };

  return(
    <Section id="family">
      <SectionTitle title={translations.family.title} ts="2"/>
      <SectionDesc value={translations.family.description}/>


      {!!isLoaded && <button 
        className="flex-row-auto items-center bg-white color-accent mx-auto gap-8 br-12 py-16 sm:py-24 px-32 sm:px-48 mt-32 fw-600 font-inter fs-16 lh-none fill-accent shadow-sm hover:shadow-md transition-fast lift-4"
        onClick={openModal}
      >
        <svg className="w-24 h-24" viewBox="0 0 0.48 0.48" xmlns="http://www.w3.org/2000/svg"><path d="M.285.225a.045.045 0 1 1-.09 0 .045.045 0 0 1 .09 0M.428.12H.352A.05.05 0 0 0 .3.172V.27A.03.03 0 0 0 .33.3v.18h.12V.3A.03.03 0 0 0 .48.27V.172A.05.05 0 0 0 .428.12"/><path  d="M.45.06a.06.06 0 1 1-.12 0 .06.06 0 0 1 .12 0M.128.15H.052a.052.052 0 1 0 0 .104.052.052 0 0 0 0-.104A.05.05 0 0 0 0 .202V.27A.03.03 0 0 0 .03.3L0 .39h.03v.09h.12V.39h.03L.15.3A.03.03 0 0 0 .18.27V.202A.05.05 0 0 0 .128.15"/><path d="M.15.09a.06.06 0 1 1-.12 0 .06.06 0 0 1 .12 0m.06.3v.09h.06V.39A.03.03 0 0 0 .3.36V.314A.044.044 0 0 0 .256.27H.224A.044.044 0 0 0 .18.314V.36a.03.03 0 0 0 .03.03"/></svg>
        {translations.family.btn}
      </button>}

      {!!showPopup && !!isLoaded && <PopupLarge onClose={closeModal}>

        <SectionTitle title={translations.family.title}/>
        <SectionDesc value={translations.family.description2}/>

          <div className="block-full bg-surface-1 p-24 br-16 bw-1 bs-solid bc-gray my-24 md:my-32 shadow-md hover:shadow-lg transition-medium lift-4">
            <div className="block-full fs-24 lh-30 sm:fs-28 sm:lh-32 mb-12 fw-600 font-inter color-header-2">{translations.family.tabs[0]}</div>
            <div className="block-full fs-16 lh-24 font-inter color-soft">{family.description || ""}</div>
          </div>

          <div className="grid-cols-1 grid-cols-md-2 gap-24 md:gap-32">
            <Card>
              <div className="flex-row-80 h-80 items-center justify-center mx-auto fs-40 br-round mb-16" style={{background: "var(--gradient-secondary)"}}>👨</div>
              <div className="block-full font-inter fw-500 fs-28 lh-36 color-highlight-2 mb-16 text-center">{translations.family.tabs[3]}</div>
              <div className="flex-row-full gap-8 font-inter fw-400 fs-16 lh-none mb-16">
                <div className="fw-600 color-strong">{translations.family.tabs[1]}:</div>
                <div className="color-normal">{family.fatherName || ""}</div>
              </div>
              <div className="flex-row-full gap-8 font-inter fw-400 fs-16 lh-none mb-16">
                <div className="fw-600 color-strong">{translations.family.tabs[2]}:</div>
                <div className="color-normal">{family.fatherProfession || ""}</div>
              </div>
              <div className="block-full font-inter fs-16 lh-24 color-soft">{family.fatherDescription || ""}</div>
            </Card>
            <Card>
              <div className="flex-row-80 h-80 items-center justify-center mx-auto fs-40 br-round shadow-light mb-16" style={{background: "var(--gradient-secondary)"}}>👩</div>
              <div className="block-full font-inter fw-500 fs-28 lh-36 color-highlight-2 mb-16 text-center">{translations.family.tabs[4]}</div>
              <div className="flex-row-full gap-8 font-inter fw-400 fs-16 lh-none mb-16">
                <div className="fw-600 color-strong">{translations.family.tabs[1]}:</div>
                <div className="color-normal">{family.motherName || ""}</div>
              </div>
              <div className="flex-row-full gap-8 font-inter fw-400 fs-16 lh-none mb-16">
                <div className="fw-600 color-strong">{translations.family.tabs[2]}:</div>
                <div className="color-normal">{family.motherProfession || ""}</div>
              </div>
              <div className="block-full font-inter fs-16 lh-24 color-soft">{family.motherDescription || ""}</div>
            </Card>
          </div>

          <div className="block-full bg-surface-1 p-16 sm:p-24 lg:p-32 br-12 mt-24 md:mt-32 mb-16 shadow-md hover:shadow-lg transition-medium zoom-2 notch-top-hover cursor-pointer">
            <div className="block-full fs-24 lh-30 sm:fs-28 sm:lh-32 mb-24 fw-600 font-inter color-header-2">{translations.family.tabs[5]}</div>

            <div className="grid-cols-1 grid-cols-md-2 gap-16 md:gap-20">
              {(family?.values??[]).map((value, index) =>{
                return <div className="flex-row-full gap-4 bg-surface-2 px-8 py-4 br-4 shadow-sm items-center" key={index}>
                          <div className="flex-row-32 h-32 items-center justify-center fs-18 lh-none shrink-0">{value.icon}</div>
                          <div className="block-full font-inter fs-16 lh-20 color-soft">{value.description}</div>
                        </div>
              })}
            </div>

            <div className="block-full fs-16 lh-24 br-8 font-inter color-soft bg-surface-2 p-16 mt-24 md:mt-32 shadow-md text-italic">{family.traditions || ""}</div>
          </div>
      </PopupLarge>}

    </Section>
  )
}

export default FamilyBackground;
